import { useState, useEffect } from 'react';
import axios from 'axios';

const useAuth = () => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Function to check authentication status
        const checkAuth = () => {
            const storedToken = localStorage.getItem('token');
            const storedUser = localStorage.getItem('user');

            if (storedToken && storedUser) {
                try {
                    const parsedUser = JSON.parse(storedUser);
                    setUser(parsedUser);
                    setToken(storedToken);
                    setIsAuthenticated(true);
                } catch (error) {
                    console.error("Failed to parse user data from localStorage:", error);
                    handleLogout();
                }
            } else {
                setIsAuthenticated(false);
                setUser(null);
                setToken(null);
            }
            setLoading(false);
        };

        // Initial check on component mount
        checkAuth();

        // Optional: Add a listener for localStorage changes
        window.addEventListener('storage', checkAuth);

        return () => {
            window.removeEventListener('storage', checkAuth);
        };
    }, []);

    const handleLogin = (newToken, newUser) => {
        localStorage.setItem('token', newToken);
        localStorage.setItem('user', JSON.stringify(newUser));
        setUser(newUser);
        setToken(newToken);
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
        setToken(null);
        setIsAuthenticated(false);
        // Clear Axios authorization header
        delete axios.defaults.headers.common['Authorization'];
    };

    return { user, token, isAuthenticated, loading, handleLogin, handleLogout };
};

export default useAuth;
